module.exports = __webpack_public_path__ + "img/icon_curriculum_logo_n.5f11819f.png";